import { render, staticRenderFns } from "./ApplicationsStatuses.vue?vue&type=template&id=0bb29fec&"
import script from "./ApplicationsStatuses.vue?vue&type=script&lang=js&"
export * from "./ApplicationsStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports